import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { FAIRE_DIRECT_BRAND_QUERY_PARAM } from "@faire/web--source/common/routes/faire-direct/FAIRE_DIRECT_BRAND_QUERY_PARAM";
import SignUpPersonalRoute, {
  QueryParameters as SignUpQueryParameters,
} from "@faire/web-api--source/routes/welcome/r/personal";

export const useFaireDirectSignUp = () => {
  const { isFaireDirectActiveInLoggedOut, faireDirectBrandAlias } =
    useFaireDirectBrand();
  const isLoggedInRetailerOrBrandPreview =
    useIsLoggedInRetailerOrBrandPreview();
  const isFaireDirectSignUpEligible =
    !isLoggedInRetailerOrBrandPreview && isFaireDirectActiveInLoggedOut;
  const faireDirectSignupRequiredEmailAddressSignUpRoute =
    isFaireDirectSignUpEligible
      ? SignUpPersonalRoute(
          SignUpQueryParameters.build({
            signUp: SignUpType.FAIRE_DIRECT_REQUIRE_EMAIL,
            [FAIRE_DIRECT_BRAND_QUERY_PARAM]: faireDirectBrandAlias,
          })
        )
      : "";
  return {
    isFaireDirectSignUpEligible,
    faireDirectSignupRequiredEmailAddressSignUpRoute,
  };
};
